import React, { useState } from 'react';
import { api } from '../services/api';

const EmailUpdate = ({ canManageAccount, onUpdated }) => {
  const [newEmail, setNewEmail] = useState('');
  const [code, setCode] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [step, setStep] = useState('request');

  const requestCode = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });
    try {
      await api.post('/acct-mgmt/v1/account/email/update', { new_email: newEmail });
      setStep('verify');
      setStatus({ type: 'success', message: 'Verification code sent.' });
    } catch (err) {
      setStatus({ type: 'danger', message: err.response?.data?.error || 'Failed to send verification code.' });
    }
  };

  const verifyCode = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });
    try {
      await api.post('/acct-mgmt/v1/account/email/verify', { new_email: newEmail, code });
      setStatus({ type: 'success', message: 'Email updated successfully.' });
      setStep('done');
      if (onUpdated) {
        onUpdated();
      }
    } catch (err) {
      setStatus({ type: 'danger', message: err.response?.data?.error || 'Failed to verify email.' });
    }
  };

  if (!canManageAccount) {
    return (
      <div className="card">
        <div className="card-body">
          <h3 className="h5 fw-bold mb-2">Update Email</h3>
          <p className="text-muted mb-0">You do not have permission to update account email.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="h5 fw-bold mb-3">Update Email</h3>
        {status.message && (
          <div className={`alert alert-${status.type}`} role="alert">{status.message}</div>
        )}
        {step === 'request' && (
          <form onSubmit={requestCode}>
            <div className="mb-3">
              <label className="form-label">New Email</label>
              <input
                type="email"
                className="form-control"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                required
              />
            </div>
            <button className="btn btn-primary" type="submit">Send Verification Code</button>
          </form>
        )}
        {step === 'verify' && (
          <form onSubmit={verifyCode}>
            <div className="mb-3 text-center">
              <label className="form-label text-center d-block">Verification Code</label>
              <input
                className="form-control"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={code.length < 6}>Verify and Update</button>
          </form>
        )}
        {step === 'done' && (
          <div className="text-muted">You can return to the overview or continue managing your account.</div>
        )}
      </div>
    </div>
  );
};

export default EmailUpdate;
